import { render, staticRenderFns } from "./ImprimirLabelSmall.vue?vue&type=template&id=bad8f24c&"
import script from "./ImprimirLabelSmall.vue?vue&type=script&lang=js&"
export * from "./ImprimirLabelSmall.vue?vue&type=script&lang=js&"
import style0 from "./ImprimirLabelSmall.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports